import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, ClothesSizeOptions, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess, ShoesSizeOptions } from "utils/Constant";
import { ApiCreateSalesStock, ApiGetProductList, ApiGetSalesStockById, ApiGetSystem, ApiUpdateSalesStock } from "utils/constants/api";
import { CheckResponse, GetPriceAfterTax, GetStatus, money, removeNonNumeric } from "utils/helpers";
import { useModal } from "components/modal/ModalContext";
import Select from 'react-select'
import moment from "moment";
import DatePicker from "components/Input/DatePicker";
import { FormCard } from "components/Cards";

export default function SalesStockForm(){
    let navigate = useNavigate()
    const { openModal, closeModal } = useModal()

    const { fetch: apiGetProductList } = useFetch(ApiGetProductList)
    const { fetch: apiCreateSalesStock } = useFetch(ApiCreateSalesStock)
    const { fetch: apiGetSalesStockById } = useFetch(ApiGetSalesStockById)
    const { fetch: apiUpdateSalesStock } = useFetch(ApiUpdateSalesStock)
    const { fetch: apiGetSystem } = useFetch(ApiGetSystem)
    
    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let salesStockId = queryString.get("salesStockId")

    const [productOptions, setProductOptions] = useState([])
    const [product, setProduct] = useState({})
    const [stockIn, setStockIn] = useState(new Date())
    const [purchasePrice, setPurchasePrice] = useState('')
    const [sellingPrice, setSellingPrice] = useState('0')
    const [discount, setDiscount] = useState('0')
    const [priceAfterDiscount, setPriceAfterDiscount] = useState('')
    const [quantity, setQuantity] = useState('1')
    const [tax, setTax] = useState('')
    const [size, setSize] = useState('')
    const [categoryId, setCategoryId] = useState('')
    const [categoryName, setCategoryName] = useState('')

    const [status, setStatus] = useState('')
    const [createBy, setCreateBy] = useState('')
    const [createDate, setCreateDate] = useState('')
    const [updateBy, setUpdateBy] = useState('')
    const [updateDate, setUpdateDate] = useState('')
    
    // Button Event
    const saveBtnClick = () => {
        if(validation()){
            openModal(ModalTypeConfirmation, {
                onConfirm: () => {
                    openModal(ModalTypeLoading)
    
                    if (formType === FormTypeAdd) {
                        createSalesStock().then((res) => {
                            if (checkResponse(res)) {
                                openModal(ModalTypeSuccess, {
                                    onSuccess: () => {
                                        closeModal()
                                        navigate("/sales-stock") 
                                    }
                                })
                            }
                        })
                    } else {
                        updateSalesStock().then((res) => {
                            if (checkResponse(res)) {
                                openModal(ModalTypeSuccess, {
                                    onSuccess: () => {
                                        closeModal()
                                        navigate("/sales-stock") 
                                    }
                                })
                            }
                        })
                    }                    
                }
            })
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }
    
    // API Calls
    const getProductList = async() => {
        let res = await apiGetProductList({
            data: {
                productName: '', 
                brandId: '',
                status: '1',
                pageSize: 10000,
                pageIndex: 0
            }
        })

        return res
    }
    const createSalesStock = async() => {
        let res = await apiCreateSalesStock({
            data: {
                productId: product.value,
                stockIn: moment(stockIn).format('YYYY-MM-DDTHH:mm'),
                purchasePrice: purchasePrice.replaceAll(',',''),
                sellingPrice: sellingPrice.replaceAll(',', ''),
                discount,
                quantity,
                size
            }
        })

        return res
    }
    const updateSalesStock = async() => {
        let res = await apiUpdateSalesStock({
            data: {
                salesStockId,
                productId: product.value,
                stockIn: moment(stockIn).format('YYYY-MM-DDTHH:mm'),
                purchasePrice: purchasePrice.replaceAll(',',''),
                sellingPrice: sellingPrice.replaceAll(',', ''),
                discount,
                size
            }
        })

        return res
    }
    const getSalesStockById = async() => {
        let res = await apiGetSalesStockById({
            data: {
                salesStockId
            }
        })

        return res
    }
    const getSystem = async() => {
        let res = await apiGetSystem({
            data: {
                systemKey: 'tax'
            }
        })

        return res
    }

    // Function
    const validation = () => {
        if (product === null){
            openModal(ModalTypeFail, { message: 'Product is required!' })
            return false
        } else if (product.value === '') {
            openModal(ModalTypeFail, { message: 'Product is required!' })
            return false
        }
        if (stockIn === null) {
            openModal(ModalTypeFail, { message: 'Stock In Date is required!' })
            return false
        }
        if (purchasePrice === '') {
            openModal(ModalTypeFail, { message: 'Purchase Price is required!' })
            return false
        }
        if (sellingPrice === '') {
            openModal(ModalTypeFail, { message: 'Selling Price is required!' })
            return false
        }
        if (discount === '') {
            openModal(ModalTypeFail, { message: 'Discount is required!' })
            return false
        } else {
            if (parseInt(discount) > 100){
                openModal(ModalTypeFail, { message: 'Discount cannot exceeded 100!' })
                return false
            }
        }
        if (quantity === '' || quantity === '0') {
            openModal(ModalTypeFail, { message: 'Quantity is required!' })
            return false
        }

        return true
    }
    const checkResponse = (res) => {
        if (res.status === ApiResponseSuccess) {
            return true
        } else if (res.status === ApiResponseStatusUnauthorized) {
            window.location.href = "/login"
            return false
        } else {
            openModal(ModalTypeFail, { message: res.message })
            return false
        }
    }

    useEffect(() => {
        if (sellingPrice !== ''){
            let disc = discount === '' ? 0 : parseFloat(discount)
            let finalPrice = parseFloat(sellingPrice.replaceAll(',', '')) * (100 - disc) / 100

            setPriceAfterDiscount(Math.round(finalPrice))
        }
    }, [sellingPrice, discount])
    
    useEffect(() => {
        openModal(ModalTypeLoading)
        
        getSystem().then((res) => {
            if (CheckResponse(res)) {
                setTax(res.data.systemValue)

                // If Form Type Edit then get data
                if (formType === FormTypeEdit) {
                    getSalesStockById().then((res) => {
                        if (CheckResponse(res)) {
                            let data = res.data

                            // Data
                            setProduct({ label: data.brandName + ' ' + data.productName.toUpperCase(), value: String(data.productId), categoryId: String(data.categoryId), categoryName: data.categoryName })
                            setCategoryName(data.categoryName)
                            setSize(data.size)
                            setStockIn(data.stockIn)
                            setPurchasePrice(money(data.purchasePrice))
                            setSellingPrice(money(Math.round(data.sellingPrice)))
                            setDiscount(data.discount === '' ? '0' : data.discount)

                            // Header
                            setStatus(data.status)
                            setCreateBy(data.createBy)
                            setCreateDate(data.createDate)
                            setUpdateBy(data.updateBy)
                            setUpdateDate(data.updateDate)

                            closeModal()
                        } else {
                            openModal(ModalTypeFail, { message: res.message })
                        }
                    })
                } else {
                    getProductList().then((res) => {
                        if (checkResponse(res)) {
                            // If Form Type Edit then get data
                            let data = res?.data?.listData
                            let tempData = [{ label: 'Select Product', value: '' }]

                            data.map((data, i) => tempData.push({ label: data.brandName + ' ' + data.productName.toUpperCase(), value: String(data.productId), price: data.price, discount: data.discount, priceAfterDiscount: data.nettPrice, categoryId: String(data.categoryId), categoryName: data.categoryName }))

                            setProductOptions(tempData)
                            
                            closeModal()
                        }
                    })
                }
            } else {
                openModal(ModalTypeFail, { message: res.message })
            }
        })
    }, [])

    return(
        <div className="flex p-3 min-h-full w-full">
            <div className="flex flex-col border justify-between gap-2 sm:bg-white sm:p-6 sm:rounded-xl sm:shadow-lg min-h-full w-full">
                <div>
                    <div className="flex justify-between">
                        <span className="font-semibold text-2xl">Sales Stock Detail</span>
                        <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                            <span className="text-sm opacity-60">
                                Status : {GetStatus(status)} | Created : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | By : {updateBy}
                            </span>
                        </div>
                    </div>
                    <hr />

                    <div className="mt-5 flex flex-col gap-3 ">
                        {/* Product */}
                        <FormCard title='Product'>
                            <Select options={productOptions} value={product} 
                                onChange={(e) => { setProduct(e); setSellingPrice(money(e.price)); setDiscount(e.discount); setPriceAfterDiscount(e.priceAfterDiscount); }} 
                                placeholder='Select Product' 
                                isDisabled={formType === FormTypeEdit ? true : false}
                            />
                        </FormCard>

                        <FormCard title='Category'>
                            <span>{product.categoryName}</span>
                        </FormCard>

                        {product.categoryId !== null && (product.categoryId === '3' || product.categoryId === '8') && 
                            <FormCard title='Size'>
                                <div className="flex gap-2">
                                    {product.categoryId === '3' && 
                                        ShoesSizeOptions.map((data, i) => 
                                            <button 
                                                className={`px-3 py-1 border rounded-full ${size === data.value ? 'bg-black text-white' : 'bg-white text-black'}`}
                                                onClick={() => setSize(data.value)}
                                                key={i}
                                            >
                                                {data.label}
                                            </button>
                                        )
                                    }
                                    {product.categoryId === '8' && 
                                        ClothesSizeOptions.map((data, i) => 
                                            <button 
                                                className={`px-3 py-1 border rounded-full ${size === data.value ? 'bg-black text-white' : 'bg-white text-black'}`}
                                                onClick={() => setSize(data.value)}
                                                key={i}
                                            >
                                                {data.label}
                                            </button>
                                        )
                                    }
                                </div>
                            </FormCard>
                        }

                        {/* Stock In Date */}
                        <FormCard title='Stock In Date'>
                            <DatePicker value={stockIn} onChange={(e) => { setStockIn(e) }} className='h-11 w-full bg-white' disableClock={true} />
                        </FormCard>
                        
                        {/* Purchase Price */}
                        <FormCard title='Purchase Price'>
                            <input className="input" value={purchasePrice} onChange={(e) => { setPurchasePrice(money(e.target.value)) }} maxLength={12} />
                        </FormCard>

                        {/* Selling Price */}
                        <FormCard title='Selling Price'>
                            <span className="">Rp {sellingPrice}</span>
                        </FormCard>
                        
                        {/* Discount */}
                        <FormCard title='Discount'>
                            <div className="flex items-center w-24">                                
                                <span className="">{discount} %</span>
                            </div>
                        </FormCard>

                        {/* Tax */}
                        <FormCard title='Tax'>
                            <div className="flex items-center w-24">                                
                                <span className="">{tax} %</span>
                            </div>
                        </FormCard>
                       
                        {/* Final Price */}
                        <FormCard title='Final Price'>
                            <span className="font-semibold">Rp {money(GetPriceAfterTax(priceAfterDiscount, tax))}</span>
                        </FormCard>

                        {/* Quantity */}
                        {formType === FormTypeAdd && 
                            <FormCard title='Quantity'>
                                <div className="flex gap-2">
                                    <button className="button" onClick={() => { setQuantity(prev => Math.max(0, parseInt(prev) - 1)) }}> - </button>
                                    <div className="w-20">
                                        <input className="input" value={quantity} onChange={(e) => { setQuantity(removeNonNumeric(e.target.value)) }} maxLength={12} />
                                    </div>
                                    <button className="button" onClick={() => { setQuantity(prev => Math.max(0, parseInt(prev === '' ? 0 : prev) + 1)) }}    > + </button>
                                </div>
                            </FormCard>
                        }
                    </div>
                </div>            

                {/* Button */}
                <div className="mt-5 flex flex-wrap justify-end gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <BackButton onClick={backBtnClick} />
                </div>
            </div>
        </div>
        
    )
}